"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderContent = exports.HeaderTitle = exports.LinkWrapper = exports.RowWrapper = exports.Header = exports.Items = exports.Section = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Section = styled_components_1.default.section ``;
exports.Items = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  margin: 0;

  & > div {
    width: 100%;
  }

  & > div:nth-child(odd):not(section) {
    ${(props) => props.isTheme && `background: ${colors_1.LIGHT_GREY}`}
  }

  @media (min-width: 1301px) and (max-width: 1640px) {
    ${(props) => props.twoCols && ` margin: 0 -8px 0;`}

    & > div {
      ${(props) => props.twoCols && `width:50%; padding: 0 16px;`}
    }

    & > div:nth-child(odd) {
      ${(props) => props.twoCols && `border-right: 1px solid ${colors_1.LIGHT_GREY};`}
    }

    & > div:nth-child(even) {
      ${(props) => props.twoCols && ` border-right: 1px solid transparent;`}
    }
  }
`;
exports.Header = styled_components_1.default.section `
  display: flex;
  font-size: 14px;
  font-weight: bold;
  color: ${colors_1.GREY4};
  margin: 20px 8px 5px;
  width: 100%;

  :first-child {
    margin-top: 2px;
  }

  > label {
    flex-grow: 1;
    width: 200px;
  }
  > span {
    width: 50px;
    text-align: center;
    font-weight: bold;

    :last-child {
      margin-right: 68px;
    }
  }
`;
exports.RowWrapper = styled_components_1.default.div `
  background-color: ${colors_1.WHITE};
`;
exports.LinkWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
`;
exports.HeaderTitle = styled_components_1.default.div `
  flex-grow: 1;
  width: 200px;

  label {
    font-weight: bold;
    font-size: 14px;
  }
`;
exports.HeaderContent = styled_components_1.default.span ``;
//# sourceMappingURL=MultiCalculationSection.styles.js.map